"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
// external
const class_validator_1 = require("class-validator");
const cloneModelObject_1 = require("../util/cloneModelObject");
const errorTypes_1 = require("../helpers/errorTypes");
/**
 * Represents a user that can access an application.
 */
class User {
    /**
     * Remove any sensitive data from the model.
     */
    filterSensitiveData() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        delete clone.passwordHash;
        delete clone.invitationCode;
        delete clone.invitationCodeExpiry;
        delete clone.invitationCodeTwoFactorCode;
        delete clone.passwordHash;
        delete clone.passwordResetToken;
        delete clone.passwordResetExpiry;
        delete clone.passwordResetTwoFactorCode;
        return clone;
    }
    /**
     * Convert into an object.
     */
    serialize() {
        return {
            id: this.id,
            email: this.email,
            passwordHash: this.passwordHash,
            active: this.active,
            suspend: this.suspend,
            invitationCode: this.invitationCode,
            invitationCodeExpiry: this.invitationCodeExpiry,
            invitationCodeTwoFactorCode: this.invitationCodeTwoFactorCode,
            passwordResetToken: this.passwordResetToken,
            passwordResetExpiry: this.passwordResetExpiry,
            passwordResetTwoFactorCode: this.passwordResetTwoFactorCode
        };
    }
    /**
     * Convert into a model.
     */
    static unserialize(data) {
        const newUser = new this();
        newUser.id = data.id;
        newUser.email = data.email;
        newUser.passwordHash = data.passwordHash;
        newUser.active = data.active;
        newUser.suspend = data.suspend;
        newUser.invitationCode = data.invitationCode;
        newUser.invitationCodeExpiry = data.invitationCodeExpiry;
        newUser.invitationCodeTwoFactorCode = data.invitationCodeTwoFactorCode;
        newUser.passwordResetToken = data.passwordResetToken;
        newUser.passwordResetExpiry = data.passwordResetExpiry;
        newUser.passwordResetTwoFactorCode = data.passwordResetTwoFactorCode;
        return newUser;
    }
    /**
     * Validate model fields.
     */
    async validate() {
        const validated = await (0, class_validator_1.validate)(this);
        if (validated.length > 0) {
            throw new errorTypes_1.ValidationError(validated);
        }
        return true;
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], User.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.IsNotEmpty)()
], User.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], User.prototype, "passwordHash", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)()
], User.prototype, "active", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)()
], User.prototype, "suspend", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], User.prototype, "invitationCode", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)()
], User.prototype, "invitationCodeExpiry", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], User.prototype, "invitationCodeTwoFactorCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], User.prototype, "passwordResetToken", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)()
], User.prototype, "passwordResetExpiry", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], User.prototype, "passwordResetTwoFactorCode", void 0);
exports.User = User;
//# sourceMappingURL=User.js.map